import Cache from '@/support/cache'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'

import i18n, { LANGUAGE_KEY, type AppLanguage, elementLocales, DEFAULT_LANGUAGE } from '@/i18n'

export function setLanguage(lang: AppLanguage) {
  const targetLang = lang || DEFAULT_LANGUAGE

  // 1. 切换 vue-i18n
  i18n.global.locale.value = targetLang

  // 2. 缓存
  Cache.set(LANGUAGE_KEY, targetLang)

  // 3. 设置 html lang
  document.documentElement.lang = targetLang

  // 4. 切换 dayjs 语言
  dayjs.locale(targetLang === 'zh' ? 'zh-cn' : 'en')
}

export function getCurrentLanguage(): AppLanguage {
  return (i18n.global.locale.value as AppLanguage) || DEFAULT_LANGUAGE
}

export function getElementLocale() {
  const lang = getCurrentLanguage()
  return elementLocales[lang]
}

// 初始化时调用一次
export function initLanguage() {
  setLanguage(getCurrentLanguage())
}
